import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

const svcLabel = (wo, sid) => {
  const s = (wo.extra_services || []).find((x) => x.id === sid);
  return s ? `${s.service_type_name} · ${s.business_unit_name}` : "Servicio adicional";
};

export const TechComments = ({ wo, setWo, canAdd, serviceId }) => {
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);
  const list = (wo.tech_comments || []).filter((c) => serviceId === undefined || (c.service_id || null) === serviceId);
  if (!list.length && !canAdd) return null;
  const add = async () => {
    setSaving(true);
    try {
      const { data } = await api.post(`/work-orders/${wo.id}/tech-comments`, { text, service_id: serviceId || null });
      setWo((w) => ({ ...w, tech_comments: [...(w.tech_comments || []), data] }));
      setText("");
      toast.success("Comentario agregado");
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  return (
    <div className="space-y-2" data-testid="tech-comments">
      <div className="text-[11px] uppercase tracking-wider text-muted-foreground">Comentarios complementarios</div>
      {list.map((c) => (
        <div key={c.id} className="rounded-lg border border-border bg-card/40 px-3 py-2" data-testid={`tech-comment-${c.id}`}>
          <p className="whitespace-pre-wrap text-sm">{c.text}</p>
          <div className="mt-1 text-xs text-muted-foreground">{c.author_name} · {fmtDateTime(c.at)}{serviceId === undefined && c.service_id ? ` · ${svcLabel(wo, c.service_id)}` : ""}</div>
        </div>
      ))}
      {canAdd && <>
        <Textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} className="text-base" placeholder="Agrega un comentario sin modificar las observaciones enviadas" data-testid="tech-comment-input" />
        <Button className="h-12 w-full" onClick={add} disabled={saving || !text.trim()} data-testid="tech-comment-add-button">Agregar comentario</Button>
      </>}
    </div>
  );
};
